import React from 'react'
import { CircularProgress } from '@mui/material'
import { FaBan } from 'react-icons/fa'
import CustomDialog from '../../../components/CustomDialog'

const RejectConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  ticketId,
  isSubmitting = false,
}) => {
  return (
    <CustomDialog
      open={open}
      width={420}
      padding={0}
      extraStyle={{ borderRadius: 8, overflow: 'hidden', padding: 0 }}
    >
      <div className="flex flex-col bg-white text-customPrimaryText dark:bg-customSurface dark:text-customHeading">
        <header className="flex items-center gap-3 border-b border-customPredawn/10 bg-customFontRed/10 px-6 py-5 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/40">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-customFontRed/20 text-customFontRed">
            <FaBan className="text-lg" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-customFontRed">Reject ticket</p>
            <h2 className="text-lg font-semibold">Voucher {ticketId ?? '-'}</h2>
          </div>
        </header>

        <section className="space-y-5 px-6 py-5 text-sm text-customSecondaryText dark:text-customMuted">
          <p>
            This action will flag the voucher for manual review and lock further live wagers linked to it.
            Please confirm you want to proceed.
          </p>
          <div className="rounded-xl border border-dashed border-customFontRed/30 bg-customFontRed/5 px-4 py-3 text-xs text-customFontRed dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/30">
            <p className="font-semibold">Impact</p>
            <ul className="mt-2 space-y-1">
              <li>- Stop settling for the selected ticket</li>
              <li>- Notify risk operations instantly</li>
              <li>- Attach rejection note to the audit trail</li>
            </ul>
          </div>
        </section>

        <footer className="flex items-center justify-end gap-3 border-t border-customPredawn/10 bg-customSlate/40 px-6 py-4 dark:border-customSurfaceMuted dark:bg-custom_dark_primary2/60">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-customPredawn/30 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-customPrimaryText transition hover:border-customPredawn/50 hover:bg-customPredawn/10 dark:border-customSurfaceMuted dark:text-customHeading"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="flex items-center gap-2 rounded-xl bg-customFontRed px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white shadow-sm transition hover:bg-customFontRed/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isSubmitting ? (
              <>
                <CircularProgress size={16} thickness={5} />
                <span>Rejecting...</span>
              </>
            ) : (
              <span>Confirm reject</span>
            )}
          </button>
        </footer>
      </div>
    </CustomDialog>
  )
}

export default RejectConfirmationModal
